import Button from '@liveauctioneers/caterwaul-components/lib/Button/Button';
import Modal from '@liveauctioneers/caterwaul-components/lib/SimpleModal/SimpleModal';
import ModalHeader from '@liveauctioneers/caterwaul-components/lib/SimpleModal/SimpleModalHeader';
import { FormattedMessage, useIntl } from '@liveauctioneers/hammer-ui-core/intl';
import * as React from 'react';
import styled from 'styled-components';

type Props = {
    setShowModal: (value: boolean) => void;
    showModal: boolean;
};

const PaysafeModal = ({ setShowModal, showModal }: Props) => {
    const { formatMessage } = useIntl();
    return (
        <Modal
            body={
                <>
                    <StyledTextContainer>
                        <FormattedMessage id="accountSettings.paysafeMessageOne" />
                    </StyledTextContainer>
                    <StyledTextContainer>
                        <FormattedMessage id="accountSettings.paysafeMessageTwo" />
                    </StyledTextContainer>
                    <StyledButtonContainer>
                        <Button onClick={() => setShowModal(false)}>
                            <FormattedMessage id="accountSettings.gotIt" />
                        </Button>
                    </StyledButtonContainer>
                </>
            }
            contentLabel="paysafeModal"
            header={
                <ModalHeader
                    onClose={() => setShowModal(false)}
                    title={formatMessage({ id: 'accountSettings.openModal' })}
                />
            }
            show={showModal}
        />
    );
};

export default PaysafeModal;

const StyledTextContainer = styled.div`
    text-align: center;
    margin-bottom: 32px;

    @media (max-width: ${({ theme }) => theme.breakpoints.tabletNarrowWidth}) {
        margin-bottom: 24px;
    }
`;

const StyledButtonContainer = styled.div`
    text-align: center;

    button {
        width: 264px;
        @media (max-width: ${({ theme }) => theme.breakpoints.tabletNarrowWidth}) {
            width: 100%;
        }
    }
`;
